import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "result layout-result-phone result-finanzierungsbestaetigung" }
const _hoisted_2 = {
  key: 0,
  class: "row layout-responsive-6"
}
const _hoisted_3 = { class: "col col-1 white" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "label margin-bottom" }
const _hoisted_6 = { class: "amount calculation-result-big margin-bottom" }
const _hoisted_7 = {
  key: 1,
  class: "label result-finanzierungsbestaetigung-error margin-bottom"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "row double-line" }, null, -1)
const _hoisted_9 = {
  key: 2,
  class: "row layout-responsive-11"
}
const _hoisted_10 = { class: "col col-1" }
const _hoisted_11 = { class: "label result-finanzierungsbestaetigung-success" }
const _hoisted_12 = { class: "col col-2" }
const _hoisted_13 = { class: "monthly-rate row" }
const _hoisted_14 = { class: "col col-2" }
const _hoisted_15 = { class: "center" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "confirmation-icon" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "confirmation-icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tooltip = _resolveComponent("tooltip")!
  const _component_icon_base = _resolveComponent("icon-base")!
  const _component_Button = _resolveComponent("Button")!
  const _component_server_error = _resolveComponent("server-error")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.showServerError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.isFinanzierung)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.textKaufpreis), 1),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", {
                      id: "immowert",
                      class: _normalizeClass(_ctx.isCalculating? 'animated-number' : '')
                    }, _toDisplayString(_ctx.immoWert.toLocaleString()) + " € ", 3)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.textFinanzierungNichtMoeglich), 1)),
            _hoisted_8,
            (_ctx.isFinanzierung)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.textMonatlicheRate), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", {
                        id: "rate",
                        class: _normalizeClass(_ctx.isCalculating? 'animated-number' : '')
                      }, _toDisplayString(_ctx.monatlicheRate.toLocaleString()) + " € ", 3),
                      _createElementVNode("span", null, [
                        _createVNode(_component_tooltip, { text: _ctx.textTooltipMonatlicheRate }, null, 8, ["text"])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              (_ctx.isFinanzierung)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_icon_base, {
                        type: "icon",
                        name: "check",
                        "additional-css-classes": "picto--extralarge"
                      })
                    ]),
                    _createVNode(_component_Button, {
                      text: _ctx.textButtonBestaetigung,
                      design: "secondary",
                      onBtnClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onButtonClicked(true))),
                      "full-width": true,
                      "tracking-category": "calc_fin_bestaetigung",
                      "tracking-action": "2_click",
                      "tracking-label": "fin-bestaetigung"
                    }, {
                      iconAfter: _withCtx(() => [
                        _createVNode(_component_icon_base, {
                          type: "icon",
                          name: "double_arrow",
                          "additional-css-classes": "icon--small icon--rotate-90"
                        })
                      ]),
                      _: 1
                    }, 8, ["text"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_icon_base, {
                        type: "icon",
                        name: "close",
                        "additional-css-classes": "picto--extralarge"
                      })
                    ]),
                    _createVNode(_component_Button, {
                      text: _ctx.textButtonKeineBestaetigung,
                      design: "secondary",
                      onBtnClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onButtonClicked(false))),
                      "full-width": true,
                      "tracking-category": "calc_fin_bestaetigung",
                      "tracking-action": "2_click",
                      "tracking-label": "keine fin-bestaetigung"
                    }, {
                      iconAfter: _withCtx(() => [
                        _createVNode(_component_icon_base, {
                          type: "icon",
                          name: "double_arrow",
                          "additional-css-classes": "icon--small icon--rotate-90"
                        })
                      ]),
                      _: 1
                    }, 8, ["text"])
                  ]))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_server_error, {
      "error-heading": _ctx.textErrorHeading,
      "error-message": _ctx.textErrorMessage,
      show: _ctx.showServerError
    }, null, 8, ["error-heading", "error-message", "show"])
  ]))
}